import { gql } from '@apollo/client';

export const UPDATE_MAIN_ADDRESS = gql`
  mutation UPDATE_MAIN_ADDRESS($addressId: ID!) {
    updateMainAddress(addressId: $addressId)
  }
`;
